module.exports = __webpack_public_path__ + "img/give-get_2x.826ee5f.png";


//////////////////
// WEBPACK FOOTER
// ./scripts/src/assets/raf/give-get_2x.png
// module id = 689
// module chunks = 0